import { Component, OnDestroy } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { OrderExchange, applyExchangeFixedPrice, canExchangeHaveFixedPrice } from '@shared-logic/orders';
import { setExchangeInOrderToGenerate } from 'src/app/redux/actions/exchange.action';
import { appState } from 'src/app/shared/interfaces/appState.interface';

/**
 * Fixed-price mark of the exchange being generated: when on, the exchange keeps its price
 * when the mother order changes. Only shown for a to-price mother.
 */
@Component({
  selector: 'app-exchange-fixed-price',
  templateUrl: './exchange-fixed-price.component.html',
  styleUrls: ['./../fields.component.scss'],
})
export class ExchangeFixedPriceComponent implements OnDestroy {
  isVisible: boolean = false;
  isFixedPrice: boolean = false;

  private order: OrderExchange | null = null;
  private exchange$: Subscription;

  constructor(private store: Store<appState>) {
    this.exchange$ = this.store.select('exchange', 'generateOrder').subscribe(generateOrder => {
      this.order = generateOrder;
      this.isVisible = canExchangeHaveFixedPrice(generateOrder);
      this.isFixedPrice = generateOrder?.exchange?.isFixedPrice ?? false;

      // A to-fix mother cannot have a fixed-price exchange.
      if (!this.isVisible && this.isFixedPrice) {
        this.setFixedPrice(false);
      }
    });
  }

  ngOnDestroy(): void {
    this.exchange$?.unsubscribe();
  }

  onChange(event: MatSlideToggleChange): void {
    this.setFixedPrice(event.checked);
  }

  private setFixedPrice(isFixedPrice: boolean): void {
    if (!this.order?.exchange) {
      return;
    }
    const exchange = applyExchangeFixedPrice(this.order.exchange, this.order, isFixedPrice);
    this.store.dispatch(setExchangeInOrderToGenerate({ exchange }));
  }
}
